var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#598BEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.536 21.5995C14.6555 21.5999 14.7736 21.5735 14.8816 21.5223C14.9896 21.4711 15.0847 21.3963 15.16 21.3035L19.024 16.5035C19.1417 16.3603 19.206 16.1808 19.206 15.9955C19.206 15.8102 19.1417 15.6306 19.024 15.4875L15.024 10.6875C14.8882 10.5241 14.6931 10.4214 14.4815 10.4019C14.27 10.3823 14.0594 10.4477 13.896 10.5835C13.7326 10.7193 13.6299 10.9144 13.6104 11.1259C13.5909 11.3375 13.6562 11.5481 13.792 11.7115L17.368 15.9995L13.912 20.2875C13.8142 20.4049 13.752 20.5479 13.7329 20.6995C13.7138 20.8512 13.7385 21.0051 13.8042 21.1431C13.8698 21.2812 13.9736 21.3975 14.1033 21.4784C14.233 21.5592 14.3832 21.6013 14.536 21.5995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLeft);
export default __webpack_public_path__ + "static/media/Button - left.e563a7330bcbfd27e3deb6fe28ebb51c.svg";
export { ForwardRef as ReactComponent };